export var GallectionSourceType = /*#__PURE__*/ function(GallectionSourceType) {
    GallectionSourceType["FEATURED_GALLERY"] = "featured_gallery";
    GallectionSourceType["NEWEST"] = "newest";
    GallectionSourceType["GALLERY"] = "gallery";
    GallectionSourceType["COLLECTION"] = "collection";
    GallectionSourceType["PRIVATE_COLLECTION"] = "private_collection";
    GallectionSourceType["ADOPTABLE_BOUGHT"] = "adoptable_bought";
    GallectionSourceType["ADOPTABLE_FOR_SALE"] = "adoptable_for_sale";
    return GallectionSourceType;
}({});
export var ExhibitionistWidgetType = /*#__PURE__*/ function(ExhibitionistWidgetType) {
    ExhibitionistWidgetType["TALL"] = "tall";
    ExhibitionistWidgetType["STRIP"] = "strip";
    ExhibitionistWidgetType["STRIP_SHORT"] = "strip_short";
    return ExhibitionistWidgetType;
}({});

//# sourceMappingURL=types.js.map